import { Header } from './Component/Head';
import { About } from './Component/About';
import { Services } from './Component/Services';
import { Portfolio } from './Component/Portfoli/Portfolio';
import { Team } from './Component/Teem/Team';
import { Booking } from './Component/Booking';
import { Footer } from './Component/Footer';
import { NavBar } from './Component/Navbar';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Header />
      <About />
      <Services />
      <Portfolio />
      <Team />
      <Booking />
      <Footer />
    </div>
  );
}

export default App;
